import { AzureDataBricksLinkedService } from './../linkedservice/azure-data-bricks.linkedservice';

import { Metamodel } from '../base/model';
import { IModel, ModelConstants, ParameterValue } from 'shell-models-lib';
import { Activity } from './activity';
import { Collection, IAttribute, IViolation } from 'app/model/base/annotation';
import { IKeyValPair } from 'app/interfaces/IKeyValPair';
import { ILibraryVal } from 'app/interfaces/ILibraryVal';
import { DatabricksParameter } from 'app/model/pipeline/databricks-parameter';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.sparkPythonActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.Python_DisplayText),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.Python_DisplayText)
    ],
    referable: true
})
export class SparkPythonActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly PYTHON_FILE: IAttribute;
    public static readonly LIBRARIES: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_PythonFile,
        constraint: {
            required: true
        },
        templatable: true,
        association: 'PYTHON_FILE'
    })
    public pythonFile?: string;

    @Metamodel.attribute({
        display: stringResources.Parameters,
        collection: Collection.Array
    })
    public parameters?: DatabricksParameter[];

    @Metamodel.attribute({
        display: format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureDataBricks_DisplayText),
        constraint: {
            required: true,
            validator: SparkPythonActivity.validateLinkedService
        },
        reference: true,
        type: AzureDataBricksLinkedService.MODEL
    })
    public linkedService?: AzureDataBricksLinkedService;

    /**
     * Parameter value for referenced linked service.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false
        },
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters: ParameterValue[] = [];

    @Metamodel.attribute({
        display: stringResources.ModelName_JarLibraries,
        collection: Collection.Array,
        templatable: true,
        association: 'LIBRARIES'
    })
    public libraries?: Array<IKeyValPair<ILibraryVal>> = [];

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }

    private static async validateLinkedService(
        dbActivity: SparkPythonActivity
    ) : Promise<IViolation[] | undefined> {
        if (dbActivity.linkedService?.useClusterMode === 'serverless') {
            return [{
                message: () => stringResources.Databricks_Serverless_Error
            }]
        }
        return undefined;
    }
}
